import { render, staticRenderFns } from "./FinanceHome.vue?vue&type=template&id=33066a90&scoped=true&"
import script from "./FinanceHome.vue?vue&type=script&lang=js&"
export * from "./FinanceHome.vue?vue&type=script&lang=js&"
import style0 from "./FinanceHome.vue?vue&type=style&index=0&id=33066a90&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33066a90",
  null
  
)

export default component.exports